export default __webpack_public_path__ + "static/media/flag-madagascar.0537a8f5.svg";